import React, { useEffect, useState } from 'react'
import Summerybox from '../../../components/Summerybox'
import PageHeading from '../../../components/PageHeading'
import FilterTable from '../../../components/FilterTable'
import HighchartsReact from 'highcharts-react-official';
import Highcharts, { color } from 'highcharts';
import { Link, useNavigate, useParams } from 'react-router-dom';
import GetInvestorTransactionDashboardData from '../../../APIs/Accounting/Investor/GetInvestorTransactionDashboardData';
import SendAmount from './SendAmount';
import Loader from '../../../components/Loader';
import GetTransactionDashboardData from '../../../APIs/Accounting/Investor/GetTransactionDashboardData';
import SideMessage from '../../../components/SideMessage';
import UpdatePaymentTransactionStatus from '../../../APIs/Investor/UpdatePaymentTransactionStatus';
import RequestAmountPopup from './RequestAmountPopup';

export default function InvestorPortfolioOverview() {
    let [overviewData, setOverviewData] = useState([])
    let [transactionTempList, setTransactionTempList] = useState([])
    let [tempTransactionTempList, setTempTransactionTempList] = useState([])
    let [investmentList, setInvestmentList] = useState([])
    let [pendingAmount, setPendingAmount] = useState(0)
    let { investmentType, payeeType, referenceId, paidName, paidId, transType, isRequestFrom, projectName } = useParams();
    let [loader, setLoader] = useState(1)
    let [showModal, setShowModal] = useState(0)
    let [showRequestModal, setShowRequestModal] = useState(0)
    let [sendAmount, setSendAmount] = useState(0)
    let [paymentDetail, setPaymentDetail] = useState(0)
    const [selectedTransferStatus, setSelectedTransferStatus] = useState('');
    let [updateStatusForm, setUpdateStatusForm] = useState({
        "paymentDetailId": 0,
        "transactionStatus": "-1",
        "transactionDate": "",
        "userId": window.userId
    })

    let [toaster, setToaster] = useState({
        type: "",
        message: "",
        show: 0
    })

    let handleChange = (e) => {
        let { name, value } = e.target
        setUpdateStatusForm((oldData) => ({ ...oldData, [name]: value }))
    }

    let saveUpdateStatus = async () => {
        if (updateStatusForm.transactionStatus !== "-1" && updateStatusForm.transactionDate !== "") {
            let response = await UpdatePaymentTransactionStatus(updateStatusForm);
            if (response.status === 1) {
                setToaster({
                    type: "Success",
                    message: response.message,
                    show: 1
                })
                getData()
            }
            else {
                setToaster({
                    type: "Alert",
                    message: response.message,
                    show: 1
                })
            }
        }
        else {
            if (updateStatusForm.transactionStatus === "-1") {
                setToaster({
                    type: "Alert",
                    message: "Please Select Transaction Status",
                    show: 1
                })
            }
            else {
                setToaster({
                    type: "Alert",
                    message: "Please Select Transaction Date",
                    show: 1
                })
            }
        }
    }

    let navigate = useNavigate()
    let getData = async () => {
        setLoader(1)
        // let response = await GetInvestorTransactionDashboardData(investorId, typeId)
        // let paytype = payeeType === 'true' ? "Vendor" : payeeType === "false" ? "NoVendor" : payeeType
        let response = await GetTransactionDashboardData(investmentType, payeeType, referenceId, paidId)
        if (response.status === 1) {
            setLoader(0)
            let data = response.responseValue
            setPendingAmount(data.portfolioOverview.pendingAmount)
            setOverviewData(data.portfolioOverview)
            setInvestmentList(data.landAreaDetails)
            if (data.transactions.length !== 0) {
                setTempTransactionTempList(data.transactions)
                setTransactionTempList(data.transactions)
            }
            else {
                setTempTransactionTempList([])
                setTransactionTempList([])
            }
        }
        else {
            setLoader(0)
        }
    }

    let handleSearchChange = (e) => {
        let value = e.target.value
        if (value === "-1") {
            setTempTransactionTempList(transactionTempList);
        } else {
            const list = transactionTempList.find(val => val.transactionStatus.toLowerCase() === value.toLowerCase());
            setTempTransactionTempList(list ? [list] : []);
        }

    }
    useEffect(() => {
        getData()
    }, [])
    const options = {
        chart: {
            type: 'pie',
            margin: [0, 0, 0, 0],
            spacingTop: 0,
            spacingBottom: 0,
            spacingLeft: 0,
            spacingRight: 0,
            height: '250px'
        },
        title: {
            verticalAlign: 'middle',
            floating: true,
            // text: "Total Investment <br/>" + (totalInvestment / 10000000).toFixed(2) + "Cr."
            text: payeeType && payeeType.toLowerCase() !== "Owner".toLowerCase() ? "Invested Amount <br/> ₹" + overviewData.amountTobePaid : "Total Amount <br/> ₹" + overviewData.amountTobePaid
        },
        plotOptions: {
            pie: {
                innerSize: '70%',
                size: "100%",
                dataLabels: {
                    enabled: false,
                },
            },
            borderRadius: 600,
        },
        colors: ["#3399FF ", "#00B8A9", "#004BB5", "#E88B00"],
        series: [
            {
                name: 'Amount',
                data: [
                    { name: "In Request Amount", y: overviewData.inRequestAmount },
                    { name: "Given Amount", y: overviewData.givenAmount },
                    { name: "Pending Amount", y: overviewData.pendingAmount },
                    { name: "Processing Amount", y: overviewData.processingAmount }
                ],
            },
        ],


    };
    return (
        <>
            <div className='row pb-3'>
                <div className='col col-md-8'>
                    <div className='d-flex flex-column gap-3'>
                        <div className='container-fluid landformconatiner p-4' style={{ maxHeight: "420px" }}>
                            {/* <PageHeading pagename="Expenses Overview" /> */}
                            <div className='d-flex flex-column flex-md-row justify-content-between pe-3 ps-3 pb-3'>
                                <PageHeading pagename={`${paidName} ${investmentType} Overview in ${projectName}`} />

                                {
                                    isRequestFrom === '1' ?
                                        <button className="btn btn-primary" type="button" class="btn btn-primary" onClick={() => { setShowRequestModal(1); setSendAmount(0) }}>
                                            Request For Payment

                                        </button> :
                                        <button className="btn btn-primary" type="button" class="btn btn-primary" onClick={() => { setShowModal(1); setSendAmount(0) }}>
                                            Send Amount

                                        </button>
                                }


                            </div>
                            <div className='expenses-conatiner' style={{ columnGap: "25px" }}>
                                <Summerybox color="#FF7043" title="Amount To Be Paid" money={overviewData && overviewData.amountTobePaid} subheading="" />
                                <Summerybox color="#004BB5" title="Pending Amount" money={overviewData && (overviewData.pendingAmount)} subheading="" />
                                <Summerybox color="#00B8A9" title="Given Amount" money={overviewData && overviewData.givenAmount} subheading="" />
                                <Summerybox color="#E88B00" title="Processing Amount" money={overviewData && overviewData.processingAmount} subheading="" />
                                <Summerybox color="#3399FF" title="In Request Amount" money={overviewData && overviewData.inRequestAmount} subheading="" />
                            </div>
                        </div>

                        {/* Table */}
                        <div className='container-fluid landformconatiner p-4'>
                            <div className='d-flex flex-column flex-md-row justify-content-between'>
                                <PageHeading pagename="Transactions Info" />
                                {/* search based on payment status */}
                                <div>
                                    <select className='form-input-box form-select pe-5' name='transactionStatus' onChange={handleSearchChange} >
                                        <option value="-1">--Select Transfer Status--</option>
                                        <option value="Pending">Pending</option>
                                        <option value="Processing">Processing</option>
                                        <option value="Completed">Completed</option>
                                        <option value="Failed">Failed</option>

                                    </select>
                                </div>
                                <FilterTable tempList={tempTransactionTempList} tempListMethod={setTempTransactionTempList} originalList={transactionTempList} isSearch={true} isdate={false} isFilter={false} isExport={false} />

                            </div>
                            <div className='pt-4'>
                                <table class="table">
                                    <thead>
                                        <tr className='table-head'>
                                            {/* <th scope="col">#</th> */}
                                            {/* <th scope="col">State</th> */}
                                            <th scope="col">Amount</th>
                                            <th scope="col">Date</th>
                                            <th scope="col">Payment Type</th>
                                            <th scope="col">Transfer Status</th>
                                            {
                                                isRequestFrom !== '1' ?
                                                    <th scope="col">Action</th> : ""
                                            }
                                        </tr>
                                    </thead>
                                    <tbody className='table-body'>
                                        {
                                            tempTransactionTempList.length !== 0 ? tempTransactionTempList.map((val, ind) => {
                                                return (
                                                    <tr >
                                                        {/* <th scope="row">{ind + 1}</th> */}
                                                        {/* <td>
                                                            <div className='d-flex flex-row gap-2'>
                                                                <div style={{ width: "30px", height: "30px", backgroundColor: "#E4E4E4", borderRadius: "15px" }}></div>
                                                                <span className='d-flex flex-column gap-1'>
                                                                    <label className='heading-project fw-semibold'>{val.investorName}</label>
                                                                </span>
                                                            </div>
                                                        </td> */}
                                                        <td>{val.amount}</td>
                                                        <td>{val.date.split("T")[0]}</td>
                                                        <td>{val.paymentType}</td>
                                                        <td style={{ color: val.transactionStatus.toLowerCase() === "Pending".toLowerCase() ? "#006aff" : val.transactionStatus.toLowerCase() === "Completed".toLowerCase() ? "green" : val.transactionStatus.toLowerCase() === "Processing".toLowerCase() ? "#E88B00" : "red" }}>{val.transactionStatus}</td>

                                                        {
                                                            isRequestFrom !== '1' ?

                                                                <td >
                                                                    {/* { */}
                                                                    {/* val.paymentStatus === "Pending" ?
                                                                    <button className="btn btn-primary" type="button" class="btn btn-primary" onClick={() => { setShowModal(1) }}>+ Send Amount</button>
                                                                    : */}
                                                                    <div class="dropdown dropend">
                                                                        <i class="bi bi-three-dots-vertical " data-bs-toggle="dropdown" aria-expanded="false"></i>

                                                                        {
                                                                            val.transactionStatus.toLowerCase().trim() !== "completed".toLowerCase().trim() ?



                                                                                <ul className="dropdown-menu mr-3">

                                                                                    {
                                                                                        val.transactionStatus !== "Requested" ?
                                                                                            <li><span className="dropdown-item" data-bs-toggle="modal" data-bs-target="#exampleModal" onClick={(() => { setUpdateStatusForm((oldData) => ({ ...oldData, "paymentDetailId": val.paymentDetailId })); setSelectedTransferStatus(val?.transactionStatus) })}>Update Status</span></li>
                                                                                            :
                                                                                            <li><span className="dropdown-item" onClick={(() => { setSendAmount(val.amount); setShowModal(1); setPaymentDetail(val.paymentDetailId); setSelectedTransferStatus(val?.transactionStatus) })}>Send Amount</span></li>
                                                                                    }
                                                                                    {/* {
                                                                                val.investorType === 1 ?
                                                                                    <li><Link className="dropdown-item" to={`/viewprofilecompany/${val.id}`}>View Details</Link></li>
                                                                                    :
                                                                                    <li><Link className="dropdown-item" to={`/viewprofileinvestor/${val.id}`}>View Details</Link></li>

                                                                            } */}
                                                                                </ul>
                                                                                : <></>
                                                                        }

                                                                    </div>
                                                                    {/* } */}
                                                                </td>
                                                                : ""
                                                        }
                                                    </tr>
                                                )
                                            }) :
                                                <>
                                                    <tr> <td colSpan="5" className='text-center'>Data Not Found</td></tr>
                                                </>
                                        }



                                    </tbody>
                                </table>
                            </div>


                        </div>

                    </div>
                </div>
                <div className='col col-md-4'>
                    <div className='d-flex flex-column gap-3' >
                        <div className='container-fluid landformconatiner p-4'>


                            <div className='row pt-3 mt-2' style={{ height: "295px" }}>
                                <HighchartsReact highcharts={Highcharts} options={options} />
                            </div>

                            <div className='d-flex flex-column gap-3 pt-5 mt-2'>

                                <div className='d-flex flex-row justify-content-between pb-2 rowBox' >
                                    <div className='d-flex flex-row gap-2'>
                                        <div className='projecticon' style={{ backgroundColor: "#3B82F6" }}>
                                            <svg width="16" height="16" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M2 0C0.895432 0 0 0.895447 0 2V16C0 17.1046 0.895432 18 2 18H16C17.1046 18 18 17.1046 18 16V2C18 0.895447 17.1046 0 16 0H2ZM5 10C5 9.44769 4.55228 9 4 9C3.44772 9 3 9.44769 3 10V14C3 14.5523 3.44772 15 4 15C4.55228 15 5 14.5523 5 14V10ZM9 6C9.55228 6 10 6.44769 10 7V14C10 14.5523 9.55228 15 9 15C8.44772 15 8 14.5523 8 14V7C8 6.44769 8.44772 6 9 6ZM15 4C15 3.44769 14.5523 3 14 3C13.4477 3 13 3.44769 13 4V14C13 14.5523 13.4477 15 14 15C14.5523 15 15 14.5523 15 14V4Z" fill={"rgba(255, 255, 255, 1)"} />
                                            </svg>

                                        </div>
                                        <span className='d-flex flex-column '>
                                            <label className='heading-project fw-semibold'>Cost per Square fit</label>
                                            {/* <label className='sub-heading-project' >Online Sell</label> */}
                                        </span>
                                    </div>
                                    <div className='d-flex flex-row'>
                                        <PageHeading pagename={`${investmentList && investmentList.costPerSquareFeet?.toFixed(2)} Sq. Ft`} />
                                    </div>
                                </div>
                                <div className='d-flex flex-row justify-content-between pb-2 rowBox' >
                                    <div className='d-flex flex-row gap-2'>
                                        <div className='projecticon' style={{ backgroundColor: "#3B82F6" }}>
                                            <svg width="16" height="16" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M2 0C0.895432 0 0 0.895447 0 2V16C0 17.1046 0.895432 18 2 18H16C17.1046 18 18 17.1046 18 16V2C18 0.895447 17.1046 0 16 0H2ZM5 10C5 9.44769 4.55228 9 4 9C3.44772 9 3 9.44769 3 10V14C3 14.5523 3.44772 15 4 15C4.55228 15 5 14.5523 5 14V10ZM9 6C9.55228 6 10 6.44769 10 7V14C10 14.5523 9.55228 15 9 15C8.44772 15 8 14.5523 8 14V7C8 6.44769 8.44772 6 9 6ZM15 4C15 3.44769 14.5523 3 14 3C13.4477 3 13 3.44769 13 4V14C13 14.5523 13.4477 15 14 15C14.5523 15 15 14.5523 15 14V4Z" fill={"rgba(255, 255, 255, 1)"} />
                                            </svg>

                                        </div>
                                        <span className='d-flex flex-column '>
                                            <label className='heading-project fw-semibold'>Total Area</label>
                                            {/* <label className='sub-heading-project' >Online Sell</label> */}
                                        </span>
                                    </div>
                                    <div className='d-flex flex-row'>
                                        <PageHeading pagename={`${investmentList && investmentList.totalArea} ${investmentList.areaUnit ? investmentList.areaUnit : 'Hect.'}`} />
                                    </div>
                                </div>


                                {
                                    payeeType && payeeType.toLowerCase() !== "Owner".toLowerCase() ?
                                        <>
                                            <div className='d-flex flex-row justify-content-between pb-2 rowBox' >
                                                <div className='d-flex flex-row gap-2'>
                                                    <div className='projecticon' style={{ backgroundColor: "#3B82F6" }}>
                                                        <svg width="16" height="16" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M2 0C0.895432 0 0 0.895447 0 2V16C0 17.1046 0.895432 18 2 18H16C17.1046 18 18 17.1046 18 16V2C18 0.895447 17.1046 0 16 0H2ZM5 10C5 9.44769 4.55228 9 4 9C3.44772 9 3 9.44769 3 10V14C3 14.5523 3.44772 15 4 15C4.55228 15 5 14.5523 5 14V10ZM9 6C9.55228 6 10 6.44769 10 7V14C10 14.5523 9.55228 15 9 15C8.44772 15 8 14.5523 8 14V7C8 6.44769 8.44772 6 9 6ZM15 4C15 3.44769 14.5523 3 14 3C13.4477 3 13 3.44769 13 4V14C13 14.5523 13.4477 15 14 15C14.5523 15 15 14.5523 15 14V4Z" fill={"rgba(255, 255, 255, 1)"} />
                                                        </svg>

                                                    </div>
                                                    <span className='d-flex flex-column '>
                                                        <label className='heading-project fw-semibold'>Per Sq. Ft. Purchase Cost</label>
                                                        {/* <label className='sub-heading-project' >Online Sell</label> */}
                                                    </span>
                                                </div>
                                                <div className='d-flex flex-row'>
                                                    <PageHeading pagename={`₹ ${investmentList && investmentList.totalArea} `} />
                                                </div>
                                            </div>
                                            <div className='d-flex flex-row justify-content-between pb-2 rowBox' >
                                                <div className='d-flex flex-row gap-2'>
                                                    <div className='projecticon' style={{ backgroundColor: "#3B82F6" }}>
                                                        <svg width="16" height="16" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M2 0C0.895432 0 0 0.895447 0 2V16C0 17.1046 0.895432 18 2 18H16C17.1046 18 18 17.1046 18 16V2C18 0.895447 17.1046 0 16 0H2ZM5 10C5 9.44769 4.55228 9 4 9C3.44772 9 3 9.44769 3 10V14C3 14.5523 3.44772 15 4 15C4.55228 15 5 14.5523 5 14V10ZM9 6C9.55228 6 10 6.44769 10 7V14C10 14.5523 9.55228 15 9 15C8.44772 15 8 14.5523 8 14V7C8 6.44769 8.44772 6 9 6ZM15 4C15 3.44769 14.5523 3 14 3C13.4477 3 13 3.44769 13 4V14C13 14.5523 13.4477 15 14 15C14.5523 15 15 14.5523 15 14V4Z" fill={"rgba(255, 255, 255, 1)"} />
                                                        </svg>

                                                    </div>
                                                    <span className='d-flex flex-column '>
                                                        <label className='heading-project fw-semibold'>Ploted Area</label>
                                                        {/* <label className='sub-heading-project' >Online Sell</label> */}
                                                    </span>
                                                </div>
                                                <div className='d-flex flex-row'>
                                                    {/* <PageHeading pagename={``} /> */}
                                                    <div className='d-flex flex-row justify-content-between pb-2 ' >
                                                        <PageHeading pagename={` ${investmentList.plotedArea ? "₹ " + investmentList.plotedArea : "-"} `} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='d-flex flex-row justify-content-between pb-2 rowBox' >
                                                <div className='d-flex flex-row gap-2'>
                                                    <div className='projecticon' style={{ backgroundColor: "#3B82F6" }}>
                                                        <svg width="16" height="16" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M2 0C0.895432 0 0 0.895447 0 2V16C0 17.1046 0.895432 18 2 18H16C17.1046 18 18 17.1046 18 16V2C18 0.895447 17.1046 0 16 0H2ZM5 10C5 9.44769 4.55228 9 4 9C3.44772 9 3 9.44769 3 10V14C3 14.5523 3.44772 15 4 15C4.55228 15 5 14.5523 5 14V10ZM9 6C9.55228 6 10 6.44769 10 7V14C10 14.5523 9.55228 15 9 15C8.44772 15 8 14.5523 8 14V7C8 6.44769 8.44772 6 9 6ZM15 4C15 3.44769 14.5523 3 14 3C13.4477 3 13 3.44769 13 4V14C13 14.5523 13.4477 15 14 15C14.5523 15 15 14.5523 15 14V4Z" fill={"rgba(255, 255, 255, 1)"} />
                                                        </svg>

                                                    </div>
                                                    <span className='d-flex flex-column '>
                                                        <label className='heading-project fw-semibold'>Per Sq. Ft. Cost To Be Paid</label>
                                                        {/* <label className='sub-heading-project' >Online Sell</label> */}
                                                    </span>
                                                </div>
                                                <div className='d-flex flex-row'>
                                                    {/* <PageHeading pagename={``} /> */}
                                                    <div className='d-flex flex-row justify-content-between pb-2 ' >
                                                        <PageHeading pagename={`${investmentList.costToBePaid ? "₹ " + investmentList.costToBePaid : "-"} `} />
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                        : ""
                                }




                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <SendAmount payeeType={payeeType} investorName={paidName} investorId={paidId} referenceId={referenceId} typeId={payeeType} pendingAmount={pendingAmount} transType={parseInt(transType)}/> */}
            {
                showModal === 1 ?
                    <SendAmount showModal={showModal} setShowModal={setShowModal} investmentType={investmentType} payeeType={payeeType} investorName={paidName} investorId={paidId} referenceId={referenceId} pendingAmount={pendingAmount} transactionType={parseInt(transType)} sendAmount={sendAmount} paymentDetailId={paymentDetail} isRequestFrom={isRequestFrom} />
                    : ""
            }
            <Loader show={loader} />


            {/* modal */}


            <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h1 class="modal-title fs-5" id="exampleModalLabel">Update Transfer Status</h1>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                            <div className='d-flex flex-column gap-2'>
                                <div className='row pb-4'>
                                    <div className='col pb-2 pb-md-0'>
                                        <div className='d-flex flex-column gap-1'>
                                            <label className='form-label'>Transfer Status</label>
                                            <select className='form-input-box form-select pe-5' name='transactionStatus' onChange={handleChange} value={updateStatusForm.transactionStatus}>
                                                <option value="-1">--Select Transfer Status--</option>
                                                {/* <option value="Pending">Pending</option>
                                                <option value="Processing">Processing</option> */}
                                                {
                                                    selectedTransferStatus.toLowerCase().trim() !== "completed".toLowerCase().trim() ?
                                                        <>
                                                            <option value="Completed">Completed</option>
                                                            <option value="Failed">Failed</option>
                                                        </>
                                                        : <></>
                                                }


                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <div className='row pb-4'>
                                    <div className='col pb-2 pb-md-0'>
                                        <div className='d-flex flex-column gap-1'>
                                            <label className='form-label'>Transfer Date</label>
                                            <input type='date' name="transactionDate" className='form-input-box' max={new Date().toISOString().split("T")[0]} id="transactionDate" onChange={handleChange} value={updateStatusForm.transactionDate} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">

                            <button type="button" class="btn btn-primary" onClick={saveUpdateStatus} data-bs-dismiss="modal" aria-label="Close">Save changes</button>
                        </div>
                    </div>
                </div>
            </div>


            {/* Modal for Request Amount  */}
            {
                showRequestModal === 1 ?
                    <RequestAmountPopup showModal={showRequestModal} setShowModal={setShowRequestModal} investmentType={investmentType} payeeType={payeeType} investorName={paidName} investorId={paidId} referenceId={referenceId} pendingAmount={pendingAmount} transactionType={parseInt(transType)} />
                    : ""
            }
            {
                toaster.show === 1 ?
                    <SideMessage show={toaster.show} type={toaster.type} message={toaster.message} close={setToaster} /> : ""
            }
        </>
    )
}
